/**
 * Categorization Module
 * Exports all categorizers and pipeline
 */

import { createPipeline, registerCategorizer, type PipelineState } from './CategorizationPipeline';
import { UserCategorizer } from './UserCategorizer';
import { RuleCategorizer } from './RuleCategorizer';
import {
  createHybridCategorizer,
  categorizeWithHybrid,
  getHybridCategorizerInfo,
  canCategorizeHybrid,
} from "./HybridCategorizer";

export { BaseCategorizer } from './BaseCategorizer';
export * from './CategorizationPipeline';
export * from "./HybridCategorizer";
export * from "./FuzzyCategorizer";
export { RuleCategorizer } from './RuleCategorizer';
export { UserCategorizer } from './UserCategorizer';

/**
 * Create a default categorization pipeline
 * @param config - Pipeline configuration
 * @returns Configured pipeline state
 */
export function createDefaultPipeline(config = {}): PipelineState {
  const pipeline = createPipeline({
    minConfidence: 0.6,
    ...config,
  });

  // Register categorizers in priority order
  registerCategorizer(pipeline, new UserCategorizer());
  registerCategorizer(pipeline, new RuleCategorizer());

  // Create hybrid categorizer state and adapter
  const hybridState = createHybridCategorizer();
  const hybridAdapter = {
    name: hybridState.name,
    priority: hybridState.priority,
    categorize: (transaction: import('../types').Transaction, context: import('../types').CategorizationContext = {}) =>
      categorizeWithHybrid(hybridState, transaction, context),
    canCategorize: (transaction: import('../types').Transaction, context: import('../types').CategorizationContext = {}) =>
      canCategorizeHybrid(hybridState, transaction, context),
    getInfo: () => getHybridCategorizerInfo(hybridState),
  };
  registerCategorizer(pipeline, hybridAdapter as any);

  return pipeline;
}
